<script setup lang="ts">
import { cn } from '@/lib/utils'

const props = defineProps<{ class?: string }>()
</script>

<template>
	<div
		:class="cn('space-y-2 sm:text-left flex flex-col text-center', props.class)"
	>
		<slot />
	</div>
</template>
